import React, { useEffect, useState } from 'react'
import TextField from "@mui/material/TextField";
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import Button from '@mui/material/Button';
import { styled } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Typography from '@mui/material/Typography';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import dayjs from 'dayjs';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import { FormControl } from '@mui/material';
import FilmFestival from './FilmFestival';
import CommerciallyOutside from './CommerciallyOutside';
import InternationalCompetition from './InternationalCompetition';
import IpAward from './IpAward';

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2),
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1),
  },
}));


const OtherDetails = ({ formData, setFormData, errors, setOtherErrors }) => {

  const [open, setOpen] = React.useState(false);
  const [openOtherDetails, setOpenOtherDetailsOpen] = React.useState(false);

  const [filmScreen, setfilmScreen] = React.useState(false);
  const [screenInside, setScreenInside] = React.useState(false);
  const [screenOutsideIndia, setScreenOutsideIndia] = React.useState(false);
  const [internationalCompetition, setInternationalCompetition] = React.useState(false);


  const handleChangeDateOfFestival = (e) => {
    if (e) {
      const formattedDate = e.format('YYYY-MM-DD');
      setFormData(prevData => ({
        ...prevData,
        date_of_festival: dayjs(formattedDate)
      }));
    }

    // Clear the error message for date_of_festival
    setOtherErrors(prevErrors => ({
      ...prevErrors,
      date_of_festival: ""
    }));
  }

  const handleChangeDateOfRelease = (e) => {
    if (e) {

      const formattedDate = e.format('DD/MM/YYYY');
      setFormData(prevData => ({
        ...prevData,
        date_of_release: dayjs(formattedDate, 'DD/MM/YYYY')
      }));
    }
    // Clear the error message for date_of_release
    setOtherErrors(prevErrors => ({
      ...prevErrors,
      date_of_release: ""
    }));
  }
  const handleChangeDateOfReleaseDate = (e) => {
    if (e) {
      const formattedDate = e.format('YYYY-MM-DD');
      setFormData(prevData => ({
        ...prevData,
        date_of_release_date: dayjs(formattedDate)
      }));
    }
    // Clear the error message for date_of_release_date
    setOtherErrors(prevErrors => ({
      ...prevErrors,
      date_of_release_date: ""
    }));
  }


  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "film_comletion_during_12month" && (value === 0 || value === "0")) {
      setFormData.is_directore_debute_film = 1;
      setOpenOtherDetailsOpen(true);
      setFormData(prevData => ({
        ...prevData,
        [name]: null
      }));
    } else {
      setFormData(prevData => ({
        ...prevData,
        [name]: value
      }));
      errors[name] = ""
      setOtherErrors(errors);
    }
  };
  const handleFilmScreenChange = (e) => {
    const { name, value } = e.target;

    if (value == 1) {
      setfilmScreen(1)
    } else {
      setfilmScreen(2)
    }

    setFormData(prevData => ({
      ...prevData,
      [name]: value
    }));
    errors[name] = ""
    setOtherErrors(errors);


    if (name === "film_comletion_during_12month" && value == "0") {
      setOpen(true);
    }

  };

  const handleScreenInsideChange = (e) => {
    const { name, value } = e.target;

    if (value == 1) {
      setScreenInside(1)
    } else {
      // console.log(value);
      setScreenInside(2)
    }

    setFormData(prevData => ({
      ...prevData,
      [name]: value
    }));
    errors[name] = ""
    setOtherErrors(errors);

  }

  const handleScreenOutsideIndiaChange = (e) => {
    const { name, value } = e.target;

    if (value == 1) {
      setScreenOutsideIndia(1)
    } else {
      // console.log(value);
      setScreenOutsideIndia(2)
    }

    setFormData(prevData => ({
      ...prevData,
      [name]: value
    }));
    errors[name] = ""
    setOtherErrors(errors);
  }

  const handleInternationalChange = (e) => {
    const { name, value } = e.target;

    if (value == 1) {
      setInternationalCompetition(1)
    } else {
      // console.log(value);
      setInternationalCompetition(2)
    }

    setFormData(prevData => ({
      ...prevData,
      [name]: value
    }));
    errors[name] = ""
    setOtherErrors(errors);
  }


  const handleCompletionClose = () => {
    setOpenOtherDetailsOpen(false)
  }

  const handleOtherDetailsClickOpen = () => {
    setOpenOtherDetailsOpen(true);
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const backendData = {
          details_of_awards_won_if_any: "null" // Example data from backend
        };

        // console.log('Raw backend data:', backendData); // Log raw data
        // Helper function to replace null or "null" with an empty string
        const replaceNull = (value) => (value === null || value === "null" ? '' : value);

        const processedData = {
          details_of_awards_won_if_any: replaceNull(backendData.details_of_awards_won_if_any)
        };

        // console.log('Processed data:', processedData); // Log processed data

        setFormData(prevData => ({
          ...prevData,
          ...processedData,
        }));
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };

    fetchData();
  }, [setFormData]);


  return (
    <>
      <h4 className="text-capitalize">
        10. Other Details<span className='text-danger'>*</span>
      </h4>
      <form>
        <div className='row'>
          <div className="col-sm-12 col-lg-12 mt-4">
            <React.Fragment>
              <div>
                <h6>A. Whether the Film has been completed during the last 12 months preceding the festival i.e 1st August, 2024 to 31st July, 2025</h6>
                <div className="form-check form-check-inline">
                  <input
                    className="form-check-input"
                    type="radio"
                    name="film_comletion_during_12month"
                    id="film_comletion_during_12month_yes"
                    value="1"
                    checked={formData.film_comletion_during_12month == 1}
                    onChange={handleChange}
                  />
                  <label className="form-check-label" htmlFor="film_comletion_during_12month_yes">
                    Yes
                  </label>
                </div>
                <div className="form-check form-check-inline">
                  <input
                    className="form-check-input"
                    type="radio"
                    name="film_comletion_during_12month"
                    id="film_comletion_during_12month_no"
                    value="0"
                    // checked={formData.film_comletion_during_12month == 0}
                    checked={formData.film_comletion_during_12month === 0 || formData.film_comletion_during_12month === '0'}
                    onChange={handleChange}
                  // onClick={handleOtherDetailsClickOpen}
                  />
                  <label className="form-check-label" htmlFor="film_comletion_during_12month_no">
                    No
                  </label>
                </div>
                {errors.film_comletion_during_12month && (
                  <p className="text-danger">{errors.film_comletion_during_12month}</p>
                )}
              </div>
              <BootstrapDialog
                onClose={handleCompletionClose}
                aria-labelledby="customized-dialog-title"
                open={openOtherDetails}
              >
                <DialogContent dividers>
                  <Typography gutterBottom>
                    The completion year of production of the films should be during the last 12 months preceding the festival i.e 1st August 2024 to 31st July 2025
                  </Typography>
                </DialogContent>
                <DialogActions>
                  <Button autoFocus onClick={handleCompletionClose}>
                    Ok
                  </Button>
                </DialogActions>
              </BootstrapDialog>
            </React.Fragment>
          </div>
        </div>

        <div className='row'>
          <div className="col-sm-12 col-lg-12 mt-4">
            <h6>B. Whether the Film has been screened in any Indian or International Film Festival</h6>
            <div className="form-check form-check-inline">
              <input
                className="form-check-input"
                type="radio"
                name="film_screened"
                id="film_screened_any_indian_international_festival_yes"
                value="1"
                checked={formData.film_screened == 1}
                onChange={handleFilmScreenChange}
              />
              <label className="form-check-label" htmlFor="inlineRadio1">
                Yes
              </label>
            </div>
            <div className="form-check form-check-inline">
              <input
                className="form-check-input"
                type="radio"
                name="film_screened"
                id="film_screened_any_indian_international_festival_no"
                value="0"
                checked={formData.film_screened === 0 || formData.film_screened === '0'}
                onChange={handleFilmScreenChange}
              />
              <label className="form-check-label" htmlFor="film_screened_any_indian_international_festival_no">
                No
              </label>
            </div>
            {errors.film_screened && (
              <p className="text-danger">{errors.film_screened}</p>
            )}
          </div>
          {(formData.film_screened == 1) ? <><FilmFestival

            setFormDataMain={setFormData}
            formDataMain={formData}
            setOtherErrors={setOtherErrors}
            errors={errors}
          /></> : <></>}

        </div>


        <div className='row'>
          <div className="col-sm-12 col-lg-12 mt-4">
            <h6>C. Whether the Film has been shown/broadcasted on the Internet/TV or any other media</h6>
            <div className="form-check form-check-inline">
              <input
                className="form-check-input"
                type="radio"
                name="film_broadcast_tv"
                id="film_shown_broadcast_on_internate_tv_yes"
                value="1"
                checked={formData.film_broadcast_tv == 1}
                onChange={handleChange}
              />
              <label className="form-check-label" htmlFor="film_shown_broadcast_on_internate_tv_yes">
                Yes
              </label>
            </div>
            <div className="form-check form-check-inline">
              <input
                className="form-check-input"
                type="radio"
                name="film_broadcast_tv"
                id="film_shown_broadcast_on_internate_tv_no"
                value="0"
                // checked={formData.film_broadcast_tv == 0}
                checked={formData.film_broadcast_tv === 0 || formData.film_broadcast_tv === '0'}
                onChange={handleChange}
              />
              <label className="form-check-label" htmlFor="film_shown_broadcast_on_internate_tv_no">
                No
              </label>
            </div>
            {errors.film_broadcast_tv && (
              <p className="text-danger">{errors.film_broadcast_tv}</p>
            )}
          </div>
        </div>

        <div className='row'>
          <div className="col-sm-12 col-lg-12 mt-4">
            <h6>D. Whether the Film has been screened commercially inside India</h6>
            <div className="form-check form-check-inline">
              <input
                className="form-check-input"
                type="radio"
                name="film_screened_inside_india"
                id="film_screened_commercially_inside_india_yes"
                value="1"
                checked={formData.film_screened_inside_india == 1}
                onChange={handleScreenInsideChange}
              />
              <label className="form-check-label" htmlFor="film_screened_commercially_inside_india_yes">
                Yes
              </label>
            </div>
            <div className="form-check form-check-inline">
              <input
                className="form-check-input"
                type="radio"
                name="film_screened_inside_india"
                id="film_screened_commercially_inside_india_no"
                value="0"
                // checked={formData.film_screened_inside_india == 0}
                checked={formData.film_screened_inside_india === 0 || formData.film_screened_inside_india === '0'}
                onChange={handleScreenInsideChange}
              />
              <label className="form-check-label" htmlFor="film_screened_commercially_inside_india_no">
                No
              </label>
            </div>
            {errors.film_screened_inside_india && (
              <p className="text-danger">{errors.film_screened_inside_india}</p>
            )}
          </div>
        </div>

        {(formData.film_screened_inside_india == 1) ?
          <>
            <div className='row'>
              <div className="col-sm-12 col-lg-12 mt-4">
                {/* <div className="input_field" */}
                {/* // style={{ */}
                {/* //   border: "1px solid #1c5768", */}
                {/* //   borderRadius: "5px", */}
                {/* // }} */}
                {/* > */}
                {/* </div> */}

                <Grid item xs={12} sm={12} md={6} lg={6}>
                  <Box style={{ width: "100%" }}>
                    <FormControl
                    // sx={{
                    //   width: {
                    //     xs: '100%',
                    //     sm: '100%',
                    //     md: '100%',
                    //     lg: '100%',
                    //   }
                    // }}
                    >
                      <LocalizationProvider dateAdapter={AdapterDayjs} >
                        <DemoContainer components={['DatePicker']}>
                          <DatePicker
                            label="Date of Release"
                            placeholder="Date of Release"
                            name="date_of_release"
                            value={formData.date_of_release}
                            onChange={handleChangeDateOfRelease}
                            minDate={dayjs('2024-08-01')}
                            maxDate={dayjs()}
                            format="DD/MM/YYYY"
                            placeholderText="DD/MM/YYYY"
                            // sx={{
                            //   '& .MuiOutlinedInput-root': {
                            //     height: {
                            //       xs: '48px',
                            //       sm: '52px',
                            //       md: '56px',
                            //       lg: '62px',
                            //     },
                            //     width: {
                            //       xs: '100%',
                            //       sm: '100%',
                            //       md: '100%',
                            //       lg: '100%',
                            //     },
                            //     borderRadius: {
                            //       xs: '4px',
                            //       sm: '5px',
                            //       md: '6px',
                            //       lg: '7px',
                            //     },
                            //   }
                            // }}
                            slotProps={{
                              textField: {
                                InputProps: { readOnly: true },
                                readOnly: true,
                              },
                            }}
                          />
                        </DemoContainer>
                      </LocalizationProvider>
                    </FormControl>
                  </Box>
                  {errors.date_of_release && (

                    <p className="text-danger">{errors.date_of_release}</p>
                  )}
                </Grid>
              </div>
            </div>
          </>
          :
          <>
          </>
        }

        <div className='row'>
          <div className="col-sm-12 col-lg-12 mt-4">
            <h6>E. Whether the Film has been screened commercially outside India</h6>
            <div className="form-check form-check-inline">
              <input
                className="form-check-input"
                type="radio"
                name="film_screened_outside_india"
                id="film_screened_commercially_outside_india_yes"
                value="1"
                checked={formData.film_screened_outside_india == 1}
                onChange={handleScreenOutsideIndiaChange}
              />
              <label className="form-check-label" htmlFor="film_screened_commercially_outside_india_yes">
                Yes
              </label>
            </div>
            <div className="form-check form-check-inline">
              <input
                className="form-check-input"
                type="radio"
                name="film_screened_outside_india"
                id="film_screened_commercially_outside_india_no"
                value="0"
                // checked={formData.film_screened_outside_india == 0}
                checked={formData.film_screened_outside_india === 0 || formData.film_screened_outside_india === '0'}
                onChange={handleScreenOutsideIndiaChange}
              />
              <label className="form-check-label" htmlFor="film_screened_commercially_outside_india_no">
                No
              </label>
            </div>
            {errors.film_screened_outside_india && (
              <p className="text-danger">{errors.film_screened_outside_india}</p>
            )}
          </div>
          {(formData.film_screened_outside_india == 1) ? <><CommerciallyOutside

            setFormDataMain={setFormData}
            formDataMain={formData}
            setOtherErrors={setOtherErrors}
            errors={errors}
          /></> : <></>}
        </div>


        <div className='row'>
          <div className="col-sm-12 col-lg-12 mt-4">
            <h6>F. Whether the Film has participated in any International Competition</h6>
            <div className="form-check form-check-inline">
              <input
                className="form-check-input"
                type="radio"
                name="film_participated_compentitaion"
                id="film_participated_in_any_compentitaion_yes"
                value="1"
                checked={formData.film_participated_compentitaion == 1}
                onChange={handleInternationalChange}
              />
              <label className="form-check-label" htmlFor="film_participated_in_any_compentitaion_yes">
                Yes
              </label>
            </div>
            <div className="form-check form-check-inline">
              <input
                className="form-check-input"
                type="radio"
                name="film_participated_compentitaion"
                id="film_participated_in_any_compentitaion_no"
                value="0"
                // checked={formData.film_participated_compentitaion == 0}
                checked={formData.film_participated_compentitaion === 0 || formData.film_participated_compentitaion === '0'}
                onChange={handleInternationalChange}
              />
              <label className="form-check-label" htmlFor="film_participated_in_any_compentitaion_no">
                No
              </label>
            </div>
            {errors.film_participated_compentitaion && (
              <p className="text-danger">{errors.film_participated_compentitaion}</p>
            )}
          </div>
          {(formData.film_participated_compentitaion == 1) ? <><InternationalCompetition

            setFormDataMain={setFormData}
            formDataMain={formData}
            setOtherErrors={setOtherErrors}
            errors={errors}
          /></> : <></>}
        </div>



        <div className='row'>
          {/* <div className="col-sm-12 col-lg-12 mt-4">
            <h6>G. Whether, it is Director(s) Debut Film</h6>
            <div className="form-check form-check-inline">
              <input
                className="form-check-input"
                type="radio"
                name="is_directore_debute_film"
                id="is_directore_debute_film_yes"
                value="1"
                checked={formData.is_directore_debute_film == 1}
                onChange={handleChange}
              />
              <label className="form-check-label" htmlFor="is_directore_debute_film_yes">
                Yes
              </label>
            </div>
            <div className="form-check form-check-inline">
              <input
                className="form-check-input"
                type="radio"
                name="is_directore_debute_film"
                id="is_directore_debute_film_no"
                value="0"
                checked={formData.is_directore_debute_film === 0 || formData.is_directore_debute_film === '0'}
                onChange={handleChange}
              />
              <label className="form-check-label" htmlFor="is_directore_debute_film_no">
                No
              </label>
            </div>
            {errors.is_directore_debute_film && (
              <p className="text-danger">{errors.is_directore_debute_film}</p>
            )}
          </div> */}

          <div className="col-sm-12 col-lg-12 mt-4">
            <h6>G. Whether Film's distribution is limited to India only</h6>
            <div className="form-check form-check-inline">
              <input
                className="form-check-input"
                type="radio"
                name="film_distribution_limited_to_india_only"
                id="film_distribution_limited_to_india_only_yes"
                value="1"
                checked={formData.film_distribution_limited_to_india_only == 1}
                onChange={handleChange}
              />
              <label className="form-check-label" htmlFor="film_distribution_limited_to_india_only_yes">
                Yes
              </label>
            </div>
            <div className="form-check form-check-inline">
              <input
                className="form-check-input"
                type="radio"
                name="film_distribution_limited_to_india_only"
                id="film_distribution_limited_to_india_only_no"
                value="0"
                // checked={formData.film_distribution_limited_to_india_only == 0}
                checked={formData.film_distribution_limited_to_india_only === 0 || formData.film_distribution_limited_to_india_only === '0'}
                onChange={handleChange}
              />
              <label className="form-check-label" htmlFor="film_distribution_limited_to_india_only_no">
                No
              </label>
            </div>
            {errors.film_distribution_limited_to_india_only && (
              <p className="text-danger">{errors.film_distribution_limited_to_india_only}</p>
            )}
          </div>
        </div>

        <div className='row'>
          <div className='col-sm-12 col-lg-12 mt-4'>

            {/* <textarea class="form-control" placeholder="Details of the Awards won(if any)" id="awards" style={{ height: "100px", borderRadius: "5px" }}
                name="details_of_awards_won_if_any"
                value={formData.details_of_awards_won_if_any}
                onChange={handleChange}
              >
              </textarea> */}
            <IpAward

              setFormDataMain={setFormData}
              formDataMain={formData}
              setOtherErrors={setOtherErrors}
              errors={errors}
            />

            {/* <label for="awards" style={{ fontWeight: "normal" }}>Details of the Awards won(if any)</label> */}

            {/* {errors.details_of_awards_won_if_any && (
              <p className="text-danger">{errors.details_of_awards_won_if_any}</p>
            )} */}
          </div>
        </div>
      </form>
    </>
  )
}

export default OtherDetails